import React from 'react';
import { parseRef } from '../utils/nameMeanings';

// Renders distinct scripture references as tappable chips that navigate the
// reader to that verse. `refs` is the dictionary scripture_refs array.
const ScriptureRefChips = ({ refs = [], onNavigate, limit = 12 }) => {
  if (!refs.length || !onNavigate) return null;
  const seen = new Set();
  const parsed = [];
  for (const r of refs) {
    const p = parseRef(r.reference || r.original || '');
    if (!p) continue;
    const key = `${p.book} ${p.chapter}`;
    if (seen.has(key)) continue;
    seen.add(key);
    parsed.push({ ...p, label: r.reference || key });
    if (parsed.length >= limit) break;
  }
  if (!parsed.length) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-1" data-testid="scripture-ref-chips">
      {parsed.map((p, i) => (
        <button
          key={i}
          onClick={(e) => { e.stopPropagation(); onNavigate(p.book, p.chapter); }}
          className="text-[11px] px-1.5 py-0.5 rounded bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors"
          data-testid={`ref-chip-${p.book}-${p.chapter}`.replace(/\s+/g, '-')}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
};

export default ScriptureRefChips;
